<template>
	<div class="group-members-card">
		<!-- Dialog Integrantes Gabinete -->
		<DialogIntegrantesGabinete 
			v-model="showDialogGabinete" 
		/>
		
		<!-- Dialog Configurar Lideranças (Grupo Eleitores) -->
		<DialogConfigurarLiderancas 
			v-model="showDialogLiderancas" 
		/>

		<!-- Ações no topo -->
		<div class="card-actions mb-4">
			<DialogConfirm
				:titulo="`${isOwner ? `Excluir` : `Sair do`} Grupo`"
				icon="mdi-delete-outline"
				:texto="`Você tem certeza que deseja ${
					isOwner ? `excluir o` : `sair do`
				} grupo ${grupo.nome_grupo}`"
				:botao="`${isOwner ? `Excluir` : `Sair do`} Grupo`"
				:confirmado="excluirGrupo"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						text
						small
						color="#F15A24"
						v-bind="attrs"
						v-on="on"
						:class="$vuetify.breakpoint.mobile ? 'action-link' : 'action-link mb-2'"
					>
						<v-icon small left>mdi-delete</v-icon>
						EXCLUIR GRUPO
					</v-btn>
				</template>
			</DialogConfirm>
			
			<v-btn
				text
				small
				color="#F15A24"
				@click="$emit('reload')"
				class="action-link"
			>
				<v-icon small left>mdi-refresh</v-icon>
				ATUALIZAR
			</v-btn>
		</div>

		<!-- Card de Membros -->
		<v-card class="members-card" elevation="1">
			<!-- Botão Adicionar Integrante -->
			<div class="add-member-button-container mb-4">
				<BtnAdicionarGrupo
					v-if="isAdmin && !isEleitoresGroup && !isGabineteGroup"
					:reload-integrantes="reloadGrupo"
					:id-grupo="grupo.id"
					:integrantes="grupo.integrantes"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							
							small
							:color="dynamicColor"
							dark
							v-bind="attrs"
							v-on="on"
							class="add-member-btn"
						>
                        Convidar Integrante
							<v-icon color="white" style="color: #fff !important">mdi-plus</v-icon>
						</v-btn>
					</template>
				</BtnAdicionarGrupo>
				
				<v-btn
					v-else-if="isOwner && isEleitoresGroup"
					class="mt-2"
					dark
					:color="dynamicColor"
					@click="showDialogLiderancas = true"
					block
				>
					<v-icon left>mdi-account-group</v-icon>
					Configurar Membros
				</v-btn>
				
				<v-btn
					v-else-if="isAdmin && isGabineteGroup"
					class="mt-2"
					dark
					:color="dynamicColor"
					@click="showDialogGabinete = true"
					block
				>
					<v-icon left>mdi-account-group</v-icon>
					Convidar Integrante
				</v-btn>
			</div>

			<!-- Seção Administradores -->
			<v-expansion-panels flat accordion class="members-sections">
				<v-expansion-panel>
					<v-expansion-panel-header class="section-header">
						<span class="section-title" :style="{ color: dynamicColor }">
							Administradores
						</span>
						<template v-slot:actions>
							<v-icon :color="dynamicColor">mdi-chevron-down</v-icon>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-list class="members-list">
							<v-list-item
								v-for="a in grupo.administradores"
								:key="a.directus_users_id.id"
								class="member-item"
							>
								<v-list-item-avatar>
									<v-img
										max-width="40px"
										height="40px"
										class="rounded-circle"
										cover
										:src="
											a.directus_users_id.avatar
												? `https://api.mylegis.com.br/assets/${a.directus_users_id.avatar}`
												: require(`@/assets/icon-person.svg`)
										"
									/>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="member-name">
										<router-link
											:to="`/painel/u/${a.directus_users_id.id}/${sanitizeTitle(
												a.directus_users_id.first_name
											)}`"
										>
											{{ a.directus_users_id.first_name }}
											{{
												a.directus_users_id.last_name !== null
													? a.directus_users_id.last_name
													: ''
											}}
										</router-link>
									</v-list-item-title>
									<v-list-item-subtitle>
										<v-chip
											v-if="isOwner && user.id == a.directus_users_id.id"
											x-small
											outlined
											color="red"
											text-color="red"
											class="owner-chip"
										>
											PROPRIETÁRIO
										</v-chip>
										<v-btn
											v-else-if="isOwner && user.id !== a.directus_users_id.id"
											@click="excluirAdmin(a.id)"
											text
											x-small
											class="remove-btn"
										>
											<v-icon small>mdi-close</v-icon>
											Remover Administrador
										</v-btn>
									</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-expansion-panel-content>
				</v-expansion-panel>

				<!-- Seção Integrantes -->
				<v-expansion-panel v-if="!isEleitoresGroup || isOwner">
					<v-expansion-panel-header class="section-header">
						<span class="section-title" :style="{ color: dynamicColor }">
							Integrantes
						</span>
						<template v-slot:actions>
							<v-icon :color="dynamicColor">mdi-chevron-down</v-icon>
						</template>
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-list class="members-list">
							<v-hover
								v-slot="{ hover }"
								v-for="a in integrantes"
								:key="a.directus_users_id.id"
								v-show="!isInAdmin(a.directus_users_id.id)"
							>
								<v-list-item class="member-item">
									<v-list-item-avatar>
										<v-img
											max-width="40px"
											height="40px"
											class="rounded-circle"
											cover
											:src="
												a.directus_users_id.avatar
													? `https://api.mylegis.com.br/assets/${a.directus_users_id.avatar}`
													: require(`@/assets/icon-person.svg`)
											"
										/>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title class="member-name">
											<router-link
												:to="`/painel/u/${a.directus_users_id.id}/${sanitizeTitle(
													a.directus_users_id.first_name
												)}`"
											>
												{{ a.directus_users_id.first_name }}
												{{
													a.directus_users_id.last_name !== null
														? a.directus_users_id.last_name
														: ''
												}}
											</router-link>
										</v-list-item-title>
										<v-list-item-subtitle>
											<v-btn
												v-if="isAdmin && hover"
												@click="tornarAdmin(a.directus_users_id.id)"
												text
												x-small
												class="make-admin-btn"
											>
												TORNAR ADMINISTRADOR
											</v-btn>
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action>
										<v-icon
											v-if="isAdmin"
											small
											:color="dynamicColor"
											@click="excluirIntegrante(a.id)"
											style="cursor: pointer"
										>
											mdi-delete
										</v-icon>
									</v-list-item-action>
								</v-list-item>
							</v-hover>
						</v-list>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-card>
	</div>
</template>

<script>
import BtnAdicionarGrupo from './BtnAdicionarGrupo.vue';
import DialogConfirm from './DialogConfirm.vue';
import DialogIntegrantesGabinete from './DialogIntegrantesGabinete.vue';
import DialogConfigurarLiderancas from './DialogConfigurarLiderancas.vue';

export default {
	name: 'GroupMembersCard',
	components: {
		BtnAdicionarGrupo,
		DialogConfirm,
		DialogIntegrantesGabinete,
		DialogConfigurarLiderancas,
	},
	props: {
		grupo: {
			type: Object,
			default: () => ({ administradores: [], integrantes: [] })
		},
		integrantes: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			showDialogGabinete: false,
			showDialogLiderancas: false,
		};
	},
	computed: {
		isAdmin() {
			return !!this.grupo.administradores.find(
				(e) => e.directus_users_id.id === this.$store.state.user.id
			);
		},
		isOwner() {
			return this.grupo.user_created === this.$store.state.user.id;
		},
		user() {
			return this.$store.state.user;
		},
		isGabineteGroup() {
			if (!this.grupo) return false;
			return this.grupo.tipo_grupo === 'gabinete' || 
				(this.grupo.nome_grupo && this.grupo.nome_grupo.includes('Gabinete'));
		},
		isEleitoresGroup() {
			if (!this.grupo) return false;
			return this.grupo.tipo_grupo === 'eleitores' ||
				(this.grupo.nome_grupo && this.grupo.nome_grupo.includes('Eleitores'));
		},
		dynamicColor() {
			return this.$route.params.id_grupo === '6f5ff131-006f-4525-9b17-75ae9674a09f' 
				? '#d8934e' 
				: '#F15A24';
		}
	},
	watch: {
		showDialogGabinete(newVal) {
			if (!newVal) {
				this.reloadGrupo();
				this.$store.dispatch('getInfo');
			}
		}
	},
	methods: {
		isInAdmin(id) {
			let eh = this.grupo.administradores.find(
				(e) => e.directus_users_id.id === id
			);
			return eh !== undefined;
		},
		async excluirGrupo() {
			if (!this.isOwner) {
				let integrante = this.grupo.integrantes.filter(
					(e) => e.directus_users_id.id === this.user.id
				);
				this.excluirIntegrante(integrante[0].id, true);
				return;
			}
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				status: 'archived',
			});
			this.$router.go(-1);
		},
		async tornarAdmin(id) {
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				administradores: {
					create: [
						{
							directus_users_id: { id: id },
							grupos_id: this.$route.params.id_grupo,
						},
					],
				},
			});
			this.reloadGrupo();
		},
		async excluirAdmin(id) {
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				administradores: { delete: [id] },
			});
			this.reloadGrupo();
		},
		async excluirIntegrante(id, admin) {
			await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
				integrantes: { delete: [id] },
			});
			this.reloadGrupo();

			if (admin) this.$router.go(-1);
		},
		reloadGrupo() {
			this.$emit('reload');
		},
		sanitizeTitle(title) {
			if (!title) return '';
			var slug = '';
			var titleLower = title.toLowerCase();
			slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
			slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
			slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
			slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
			slug = slug.replace(/đ/gi, 'd');
			slug = slug.replace(/\s*$/g, '');
			slug = slug.replace(/\s+/g, '-');
			return slug;
		},
	},
};
</script>

<style scoped>
.group-members-card {
	width: 100%;
}

.card-actions {
	display: flex;
	flex-direction: column;
	gap: 4px;
	align-items: flex-end;
}

/* No mobile, botões lado a lado */
@media (max-width: 960px) {
	.card-actions {
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
		gap: 8px;
	}
	
	.action-link {
		margin-bottom: 0 !important;
	}
}

.action-link {
	text-transform: uppercase;
	font-size: 0.75rem;
	font-weight: 500;
	padding: 4px 8px;
}

.members-card {
	background: white;
	border-radius: 8px;
	padding: 16px;
}

.add-member-button-container {
	display: flex;
	justify-content: center;
	align-items: center;
}

.add-member-btn {
	/* width: 48px !important; */
	/* height: 48px !important; */
	/* min-width: 48px !important; */
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
}

.add-member-btn:hover {
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3) !important;
	transform: translateY(-1px);
}

.members-sections {
	margin-top: 16px;
}

.section-header {
	padding: 12px 0;
}

.section-title {
	font-weight: bold;
	font-size: 1rem;
	text-transform: uppercase;
}

.members-list {
	padding: 0;
}

.member-item {
	padding: 8px 0;
	border-bottom: 1px solid #f0f0f0;
}

.member-item:last-child {
	border-bottom: none;
}

.member-name {
	font-size: 0.875rem;
	font-weight: 500;
}

.member-name a {
	text-decoration: none;
	color: #333;
}

.member-name a:hover {
	color: v-bind('dynamicColor');
	text-decoration: underline;
}

.owner-chip {
	font-size: 0.65rem;
	font-weight: 600;
	height: 20px;
	padding: 0 6px;
}

.remove-btn,
.make-admin-btn {
	font-size: 0.7rem;
	text-transform: uppercase;
	font-weight: 500;
	color: v-bind('dynamicColor');
}

.remove-btn:hover,
.make-admin-btn:hover {
	background-color: rgba(241, 90, 36, 0.1);
}

:deep(.v-expansion-panel-header) {
	padding: 12px 0;
	min-height: 48px;
}

:deep(.v-expansion-panel-content__wrap) {
	padding: 0;
}
</style>

